import { render, staticRenderFns } from "./SummaryInfoList.vue?vue&type=template&id=23a3779a&scoped=true&"
import script from "./SummaryInfoList.vue?vue&type=script&lang=js&"
export * from "./SummaryInfoList.vue?vue&type=script&lang=js&"
import style0 from "./SummaryInfoList.vue?vue&type=style&index=0&id=23a3779a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3779a",
  null
  
)

export default component.exports